import React, { useState } from 'react';
import { Apple, Monitor } from 'lucide-react';

const AndroidIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor"><path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85-.29-.15-.65-.06-.83.22l-1.88 3.24a11.46 11.46 0 00-8.94 0L5.65 5.67c-.19-.28-.54-.37-.83-.22-.3.16-.42.54-.26.85L6.4 9.48A10.81 10.81 0 001 18h22a10.81 10.81 0 00-5.4-8.52zM7 15.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm10 0a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z"/></svg>
);

const OPTIONS = [
  { key: 'android', Icon: AndroidIcon, label: 'ANDROID' },
  { key: 'ios', Icon: Apple, label: 'iOS / IPHONE' },
  { key: 'emulador', Icon: Monitor, label: 'EMULADOR', sub: '+ BYPASS' },
];

export const DeviceIntro = ({ isBrazil, onSelect }) => {
  const [closing, setClosing] = useState(false);
  const [picked, setPicked] = useState(null);

  const handlePick = (key) => {
    if (closing) return;
    setPicked(key);
    setClosing(true);
    setTimeout(() => onSelect(key), 420);
  };

  return (
    <div
      className={`fixed inset-0 z-[100] bg-black flex items-center justify-center px-4 sm:px-6 ${closing ? 'device-intro-exit' : ''}`}
      data-testid="device-intro-overlay"
    >
      <div className="relative z-10 w-full max-w-3xl text-center">
        <p className="device-intro-anim text-red-500 text-xs sm:text-sm font-bold tracking-[0.2em] uppercase mb-3" style={{ animationDelay: '40ms' }}>
          {isBrazil ? 'ANTES DE COMECAR' : 'BEFORE WE START'}
        </p>
        <h1 className="device-intro-anim text-2xl sm:text-4xl md:text-5xl font-black text-white gaming-title mb-3" style={{ animationDelay: '110ms' }}>
          {isBrazil ? 'QUAL O SEU DISPOSITIVO?' : 'WHAT IS YOUR DEVICE?'}
        </h1>
        <p className="device-intro-anim text-gray-400 text-sm sm:text-base mb-8 sm:mb-10" style={{ animationDelay: '180ms' }}>
          {isBrazil ? 'Escolha pra ver direto o painel certo pra voce' : 'Pick one to jump straight to the right panel'}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
          {OPTIONS.map((opt, i) => (
            <button
              key={opt.key}
              onClick={() => handlePick(opt.key)}
              style={{ animationDelay: `${260 + i * 90}ms` }}
              className={`device-intro-anim group relative flex flex-col items-center justify-center gap-3 py-8 sm:py-10 px-4 rounded-2xl border transition-all duration-300 active:scale-[0.96] ${
                picked === opt.key
                  ? 'bg-gradient-to-b from-red-600 to-red-700 border-red-500'
                  : 'bg-gray-900/60 border-gray-800 hover:border-red-500/60 hover:bg-gray-900'
              }`}
              data-testid={`device-intro-option-${opt.key}`}
            >
              <opt.Icon className="w-9 h-9 sm:w-10 sm:h-10 text-red-500 group-hover:scale-110 transition-transform duration-300" style={{ filter: 'drop-shadow(0 0 10px rgba(239,68,68,0.5))' }} />
              <span className="text-white font-bold text-sm sm:text-base gaming-title tracking-wide">{opt.label}</span>
              {opt.sub && <span className="text-red-500 text-[10px] tracking-widest -mt-2">{opt.sub}</span>}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DeviceIntro;
